import React, { useEffect, useState } from "react";
import axios from "axios";
import FormatDate from "../../formatdatetime";
import { Link } from "react-router-dom";
import CreateTicket from "./CreateTicket";
import ViewwholeTicket from "./ViewwholeTicket";
import { baseurl } from "../../constant";
import Loading from "../../loading";
const ViewTicket = () => {
  const [data, setdata] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalrecord, settotalrecord] = useState();

  const [keyword, setkeyword] = useState();
  const [status, setstatus] = useState();
  const [totalCRAmount, settotalCRAmount] = useState();
  const [totalCRRecord, settotalCRRecord] = useState();
  const [totalDRAmount, settotalDRAmount] = useState();
  const [totalDRRecord, settotalDRRecord] = useState();
  const [by, setby] = useState();
  const [ticket_id, setticket_id] = useState();
  const [active, setactive] = useState(1);
  const [id, setid] = useState();
  const [itemsubject, setitemsubject] = useState();
  const [itemstarus, setitemstatus] = useState();
  const [loading, setloading] = useState();

  const clickactive = async (act) => {
    setactive(act);
  };

  // const tableRef = useRef(null);

  // const { onDownload } = useDownloadExcel({
  //   currentTableRef: tableRef.current,
  //   filename: "Users table",
  //   sheet: "Users",
  // });

  // const navigate = useNavigate();
  const viewall = () => {
    setkeyword("");
    setstatus("");
    getdata();
  };

  const token = localStorage.getItem("authToken");
  const pageRecord = 50;
  const totalPage = Math.ceil(totalrecord / pageRecord);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  var pages = [];
  const maxvisablepage = 8;
  if (totalPage <= maxvisablepage) {
    for (let i = 1; i <= totalPage; i++) {
      pages.push(i);
    }
  } else {
    if (currentPage <= 3) {
      // Show first 3 pages, then ellipsis, then last page
      pages.push(1, 2, 3, ".......", totalPage);
    } else if (currentPage >= totalPage - 2) {
      // Show first page, then ellipsis, then last 3 pages
      pages.push(1, totalPage - 2, totalPage - 1, totalPage);
    } else {
      // Show first page, ellipsis, current page & its neighbors, ellipsis, last page
      pages.push(
        1,

        currentPage - 1,
        currentPage,
        currentPage + 1,

        totalPage
      );
    }
  }

  const getdata1 = async () => {
    setloading(true);
    const result = await axios.post(baseurl + "getTicketList", {
      token: token,
      pageno: currentPage,
      pageRecord: pageRecord,
      keyword: keyword,
    });
    setdata(result.data);
    settotalrecord(result.data.totalRecord);
    setloading(false);
  };

  const getdata = async () => {
    setloading(true);
    const result = await axios.post(baseurl + "getTicketList", {
      token: token,
      pageno: currentPage,
      pageRecord: pageRecord,

      // keyword: keyword,
      // status: status,
    });
    setdata(result.data);
    settotalCRAmount(result.data.totalCRAmount);
    settotalCRRecord(result.data.totalCRRecord);
    settotalDRAmount(result.data.totalDRAmount);
    settotalDRRecord(result.data.totalDRRecord);
    settotalrecord(result.data.totalRecord);
    setticket_id(result.data.ticket_id);
    setloading(false);
  };
  useEffect(() => {
    getdata();
  }, [currentPage]);

  return (
    <>
      {loading ? (
        <div>
          <Loading />
        </div>
      ) : (
        <div>
          {active == 1 && (
            <div>
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <div className="row">
                    <div className="col-sm-7">
                      <h4>
                        <b>My Support Tickets</b>
                      </h4>
                    </div>
                    <div className="col-sm-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Keyword"
                        name="keyword"
                        id="keyword"
                        value={keyword}
                        onChange={(e) => setkeyword(e.target.value)}
                      />
                    </div>
                    <div className="col-sm-3">
                      <button
                        type="button"
                        className="btn btn-success"
                        id="ticketSearchBtn"
                        onClick={getdata1}
                      >
                        Search
                      </button>
                      <button
                        className="btn btn-success"
                        onClick={() => clickactive(2)}
                        style={{ margin: "5px" }}
                      >
                        Create Ticket
                      </button>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table
                      className="table table-bordered table-striped"
                      id="ticketDataTable"
                      width="100%"
                      cellspacing="0"
                    >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>TicketID</th>
                          <th>Subject</th>
                          <th>Related To</th>
                          <th>Last Update</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tfoot>
                        {data
                          ? data.data.map((item, index) => (
                              <tr>
                                <td>
                                  {(currentPage - 1) * pageRecord + index + 1}
                                </td>

                                <td
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    clickactive(3);
                                    setid(item.id);
                                    setticket_id(item.ticket_id);
                                    setitemsubject(item.subject);
                                    setitemstatus(item.status_title);
                                  }}
                                >
                                  {item.ticket_id}
                                </td>

                                <td>{item.subject}</td>
                                <td>{item.related_to_title}</td>
                                <td>{FormatDate(item.updated)}</td>
                                <td>{item.status_title}</td>
                              </tr>
                            ))
                          : ""}
                      </tfoot>
                      <tbody></tbody>
                    </table>
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage == 1}
                      style={{
                        padding: "10px 15px",
                        margin: "5px",

                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      previous
                    </button>

                    {pages.map((page, index) => (
                      <button
                        key={index}
                        onClick={() => page !== "..." && handlePageChange(page)}
                        style={{
                          padding: "10px 15px",
                          margin: "5px",
                          backgroundColor:
                            currentPage === page ? "red" : "#f0f0f0",
                          color: currentPage === page ? "#fff" : "#000",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          cursor: page === "..." ? "default" : "pointer",
                          fontWeight: page === "..." ? "bold" : "normal",
                        }}
                        disabled={page === "..."}
                      >
                        {page}
                      </button>
                    ))}

                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage == totalPage}
                      style={{
                        padding: "10px 15px",
                        margin: "5px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {active == 2 && <CreateTicket />}
          {active == 3 && (
            <ViewwholeTicket
              ticket_id={ticket_id}
              itemsubject={itemsubject}
              itemstarus={itemstarus}
              id={id}
            />
          )}
        </div>
      )}
    </>
  );
};

export default ViewTicket;
